import { render, staticRenderFns } from "./index-skeleton.vue?vue&type=template&id=389c0a20&scoped=true&"
import script from "./index-skeleton.vue?vue&type=script&lang=js&"
export * from "./index-skeleton.vue?vue&type=script&lang=js&"
import style0 from "./index-skeleton.vue?vue&type=style&index=0&id=389c0a20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c0a20",
  null
  
)

export default component.exports